import Head from 'next/head';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

interface SeoProps {
  description?: string;
  title?: string;
  image?: string;
  url?: string;
}

const SeoHead = ({ title, description, url }: SeoProps) => {
  const t = useTranslations('Common');
  const { locale, asPath, pathname } = useRouter();

  const seoTitle = title || t('metaTitle');
  const seoDescription = description || t('metaDescription');

  const seoImage = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/images/og-image.jpg`;
  const seoUrl =
    url ||
    `${process.env.NEXT_PUBLIC_FRONTEND_URL}${
      locale !== 'en' ? `/${locale}` : ''
    }${asPath === '/' ? '' : asPath}`;

  const canonicalUrl =
    pathname === '/check-result/[id]'
      ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}${
          locale !== 'en' ? `/${locale}` : ''
        }`
      : seoUrl;

  return (
    <Head>
      <title>{seoTitle}</title>

      {/* MAIN */}
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* FACEBOOK */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:locale" content={locale} />
      <meta property="og:type" content="website" />

      {/* TWITTER */}
      <meta property="twitter:site" content="@imeicheck" />
      <meta
        property="twitter:domain"
        content={process.env.NEXT_PUBLIC_FRONTEND_URL}
      />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />
      <meta name="application-name" content={seoTitle} />
      <meta name="msapplication-TileColor" content="#FFFFFF" />
      <meta name="msapplication-TileImage" content={seoImage} />
    </Head>
  );
};

export default SeoHead;
